<img [src]="src" alt="" (click)="goToLink()">